import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import axios from 'axios';

/**
 * @param {Object<string, any>} config
 * @param {object} interceptors
 * @param {Array<function>} interceptors.request
 * @param {Array<function>} interceptors.response
 * @returns {AxiosInstance}
 */
function createRequestInstance(config, interceptors) {
  var instance = axios.create(config);
  if (interceptors) {
    var request = interceptors.request,
        response = interceptors.response;

    if (request && request.length) {
      var _instance$interceptor;

      (_instance$interceptor = instance.interceptors.request).use.apply(_instance$interceptor, _toConsumableArray(request));
    }
    if (response && response.length) {
      var _instance$interceptor2;

      (_instance$interceptor2 = instance.interceptors.response).use.apply(_instance$interceptor2, _toConsumableArray(response));
    }
  }
  return instance;
}

export default createRequestInstance;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/request/createRequestInstance.js
// module id = 727
// module chunks = 0